















import RecommendItem from '@pages/home/components/recommend/recommend_item.vue'
import SearchLoadList from '@pages/search/components/mixins/LoadList'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import WaterFall from '@shared/components/waterFall/index.vue'
import { List, Toast, Sticky } from 'vant'
import { getRecommend } from '@pages/home/home-service'

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    RecommendItem,
    WaterFall,
  },
})
export default class RecommendTab extends Mixins(SearchLoadList) {
  @Prop({ default: () => ({}) }) readonly tab!: any
  @Prop() readonly selectedBaby!: any
  @Prop() readonly templateType!: number
  @Prop() readonly location!: any

  pagenum = 0
  pagesize = 10
  babyage = 0

  mounted() {
    // 通用模板入参0；个性化模板入参选择宝宝、没选入参2
    if (this.templateType == 1) {
      this.babyage = (this.selectedBaby && this.selectedBaby.type) || 2 //0：不限，1：孕期，2：0-36个月、3：36个月以上
    }
    this.onLoad()
  }

  async onLoad() {
    const param: any = {
      tabId: this.tab.tabId,
      babyage: this.babyage,
      pagenum: this.pagenum,
      pagesize: this.pagesize,
    }
    if (this.location && this.location.lng) {
      param.longitude = this.location.lng
    }
    if (this.location && this.location.lat) {
      param.latitude = this.location.lat
    }

    const result = await getRecommend(param)
    const { errno = -1, errmsg } = result
    const rmdlist: any = result.rmdlist || []
    if (+errno === 0) {
      const dataList = rmdlist.map((item: any) => item.data)
      if (dataList.flat().length < this.pagesize) {
        this.loading = false
        this.finished = true
      }
      this.pagenum++
      this.list.push(...rmdlist)
    } else {
      this.errormsg = errmsg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    // 待瀑布流组装完高度撑起来后才让继续加载
    setTimeout(() => {
      this.loading = false
    }, 500)
  }

  async refresh() {
    this.reset()
    this.onLoad()
  }
}
